import { CardTitle } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

interface JobLocationMapProps {
  location: string;
}

export function JobLocationMap({ location }: JobLocationMapProps) {
  const { t } = useTranslation(["talent"]);

  if (!location) {
    return null;
  }

  const encodedLocation = encodeURIComponent(location);
  // Using Google Maps embed without API key is supported for simple search queries
  const mapUrl = `https://maps.google.com/maps?q=${encodedLocation}&t=&z=13&ie=UTF8&iwloc=&output=embed`;

  return (
    <div className="mb-6 flex-1 flex flex-col h-full min-h-[300px]">
      <CardTitle className="text-lg mb-2 text-gray-900 font-medium">
        {t("talent:jobs.location_map_title")}
      </CardTitle>
      <div className="flex-1 rounded-md overflow-hidden border border-gray-200 mt-2">
        <iframe
          title={t("talent:jobs.location_map_title")}
          width="100%"
          height="100%"
          style={{ border: 0, minHeight: "300px" }}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src={mapUrl}
        />
      </div>
    </div>
  );
}
